import FolderIcon from "@mui/icons-material/Folder";
import { Box, Typography } from "@mui/material";

import type { FolderSummary, FolderTreeNode } from "../../types/project-storage.types";
import { sortBySortOrder } from "../../utils/folder-tree";

type FolderCardItem = Pick<
  FolderSummary | FolderTreeNode,
  "id" | "displayName" | "sortOrder"
>;

type Props = {
  folders: FolderCardItem[];
  folderCounts: Record<string, number>;
  onSelectFolder: (folderId: string) => void;
};

export function SubfolderGrid({
  folders,
  folderCounts,
  onSelectFolder,
}: Props) {
  const sortedFolders = sortBySortOrder(folders);

  if (sortedFolders.length === 0) {
    return null;
  }

  return (
    <Box
      display="grid"
      gridTemplateColumns={{
        xs: "1fr",
        sm: "repeat(2, 1fr)",
        md: "repeat(3, 1fr)",
      }}
      gap={2}
    >
      {sortedFolders.map((folder) => {
        const count = folderCounts[folder.id] ?? 0;

        return (
          <Box
            key={folder.id}
            onClick={() => onSelectFolder(folder.id)}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: 1.5,
              px: 2,
              py: 2,
              minHeight: 56,
              borderRadius: 1,
              border: "1px solid #E5E7EB",
              bgcolor: "#FFFFFF",
              cursor: "pointer",
              transition: "box-shadow 0.15s ease, border-color 0.15s ease",
              "&:hover": {
                borderColor: "#1361A4",
                boxShadow: "0px 2px 8px rgba(19, 97, 164, 0.12)",
              },
            }}
          >
            <FolderIcon sx={{ color: "#1361A4", fontSize: 24 }} />
            <Typography
              flex={1}
              fontSize={14}
              fontWeight={500}
              color="#1F2937"
              noWrap
            >
              {folder.displayName}
            </Typography>
            {count > 0 && (
              <Box
                component="span"
                sx={{
                  minWidth: 18,
                  height: 14,
                  px: 0.5,
                  borderRadius: "4px",
                  bgcolor: "#E5E7EB",
                  color: "#4B5563",
                  fontSize: 10,
                  fontWeight: 600,
                  lineHeight: "14px",
                  textAlign: "center",
                }}
              >
                {count}
              </Box>
            )}
          </Box>
        );
      })}
    </Box>
  );
}
